module.exports = __webpack_public_path__ + "static/media/agilidade.1dc144cb.jpg";